import React from 'react';
import styles from './BlogPostCard.module.scss';

interface IBlogPostCardProps {
  title: string;
  imageUrl: string;
  url: string;
  className?: string;
}

export default function BlogPostCard({
  title, imageUrl, url, className = ''
}: IBlogPostCardProps) {
  return (
    // eslint-disable-next-line
    <a className={`${styles.BlogCard} ${className}`} target={'_blank'} role="button" href={url}>
      <div className={styles.Contents}>
        <img src={imageUrl} alt={title} />
        <div className={styles.BlogText}>
          {/* eslint-disable-next-line react/no-danger */}
          <span className={styles.BlogTitle}>
            {title}
          </span>
          <span className={styles.ReadMore}>
            <strong>Read More</strong>
          </span>
        </div>
        <div className={ styles.Overlay } />
      </div>
    </a>
  );
}
